var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEventStartWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "events",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_event_start_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "start"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.94,146.87l.7-.93c.54-.62,1.08-.85,1.7-.31.77.7,6.5,6,14.31,6,7,0,13-4.72,13-10.37,0-6.88-5.65-10-15-13.15-9-3.18-14.93-6.35-14.93-15.25,0-5.8,4.64-13.69,16.71-13.69a25.4,25.4,0,0,1,13.31,4A1.1,1.1,0,0,1,55,104.7a6.48,6.48,0,0,0-.62,1c-.47.63-.93.86-1.7.4-.24-.16-5.42-3.64-11.38-3.64-9.51,0-13.07,5.88-13.07,10.29,0,6.57,5,9.43,12.84,12,10.6,3.64,17.33,7.35,17.33,16.33,0,7.73-8,13.77-16.86,13.77a25.22,25.22,0,0,1-16.41-6.35C24.71,148.11,24.32,147.72,24.94,146.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.43,103.23H63.65c-.78,0-1-.46-1-1.16v-1.16a1,1,0,0,1,1-1H96.92a1,1,0,0,1,1,1v1.32a1,1,0,0,1-1,1H82.06v49.83c0,.54-.46,1-1.23,1h-1.4a1,1,0,0,1-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.93,153.14l23.83-53.86a1.08,1.08,0,0,1,.93-.54h.23a1,1,0,0,1,1,.54l23.6,53.86c.16.46.16.92-.69.92h-2a1.25,1.25,0,0,1-1.08-.69l-6.27-14.24H105.91l-6.19,14.24a1.24,1.24,0,0,1-1.08.69H96.47C95.93,154.06,95.7,153.75,95.93,153.14Zm38.22-17-13.23-31.17h-.16L107.3,136.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154.22,100.91a1,1,0,0,1,1-1h19.19c9.44,0,17.25,7.12,17.25,16.56,0,7.82-5.42,14.08-12.76,16.17l11.29,20c.39.62.23,1.39-.54,1.39h-2.4a1.09,1.09,0,0,1-1.08-.69L175,133.1c-1,.07-1.86.07-2.86.07H157.85v19.89c0,.54-.46,1-1.24,1h-1.39a1,1,0,0,1-1-1Zm20,29A13.52,13.52,0,0,0,188,116.46c0-7.35-6.27-13-13.77-13H157.93v26.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.5,103.23H197.73c-.78,0-1-.46-1-1.16v-1.16a1,1,0,0,1,1-1H231a1,1,0,0,1,1,1v1.32a1,1,0,0,1-1,1H216.14v49.83c0,.54-.47,1-1.24,1h-1.39a1,1,0,0,1-1-1Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEventStartWhite);
export default __webpack_public_path__ + "static/media/icon_event_start_white.7258ad4b1922015fc609c5ecbe415f14.svg";
export { ForwardRef as ReactComponent };